<template>
  <v-dialog v-model="show" width="50vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"
        >Actualizar Pozo "<span class="font-weight-bold font-italic">
          {{ wellSelected.value }}</span
        >"</v-card-title
      >
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="currentFolio"
                  dense
                  outlined
                  clearable
                  item-text="folioAnalysis"
                  :search-input.sync="search"
                  :items="foliosList"
                  label="Selecciona folio en pozo"
                  :loading="searching"
                  return-object
                  :rules="[(v) => !!v || 'Campo obligatorio']"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="replica"
                  dense
                  outlined
                  clearable
                  type="number"
                  label="Inggresa el número de replica"
                  :rules="[(v) => !!v || 'Campo obligatorio']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="gray"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cerrar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="saveData"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data: () => ({
    isLoading: false,
    foliosList: [],
    search: null,
    searching: false,
    user: JSON.parse(localStorage.getItem("user")),
    currentFolio: null,
    replica: null,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("molecularPlateWell", ["wellSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async mounted() {
    await this.getCurrentFolio();
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("reception", ["searchReceptionByFolio"]),
    ...mapActions("molecularPlateWell", ["assignSampleToWell"]),
    async getFolio(value) {
      try {
        this.searching = true;
        let payload = {
          laboratory: this.user.laboratory._id,
          search: value,
        };
        let response = await this.searchReceptionByFolio(payload);
        this.foliosList = response.folios;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: `Algo salió mal. Error: ${error.message}`,
          timeout: 5000,
        });
      } finally {
        this.searching = false;
      }
    },
    async saveData() {
      try {
        this.isLoading = true;
        if (this.$refs.form.validate()) {
          let payload = {
            position: this.wellSelected.position,
            sampleId: this.currentFolio.container.sample._id,
            replica: this.replica,
            molecularPlate: this.wellSelected.plateFolio,
            sampleType: this.currentFolio.container.sample.sampleType,
          };
          await this.assignSampleToWell(payload);
          this.wellSelected.folioAnalysis = this.currentFolio.folioAnalysis;
          this.wellSelected.replica = this.replica;
          this.wellSelected.sampleType =
            this.currentFolio.container.sample.sampleType;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Pozo actualizado`,
            timeout: 3000,
          });
          this.$emit("close_update");
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: `Algo salió mal. Error: ${error.message}`,
          timeout: 5000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    closeModal() {
      this.show = false;
    },
    async getCurrentFolio() {
      if (!this.wellSelected.folioAnalysis) return;
      await this.getFolio(this.wellSelected.folioAnalysis);
      if (this.foliosList.length > 0) {
        this.currentFolio = this.foliosList[0];
      }
      this.replica = this.wellSelected.replica;
    },
  },
  watch: {
    async search(newValue) {
      if (!newValue) return;
      await this.getFolio(newValue);
    },
  },
};
</script>
